import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Constants } from '../../../core/services/constants.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpService } from '../../../core';
import { UserService } from '../../../core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';


@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-company.component.html',
  styleUrls: ['./edit-company.component.scss']
})

export class EditCompanyComponent implements OnInit {

  selectedImage = [];
  selectedBanner = [];
  reactiveForm: FormGroup;
  company: any;
  highestRole: any;
  SERVER_URL = environment.SERVER_URL;

  public style = 'padding: 12px 20px; border: 0; width: 43%; outline: none; borderRadius: 4px;background:#161616;color:#dedede;';


  constructor(private formBuilder: FormBuilder,
    private httpService: HttpService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private toastrService: ToastrService) {
    this.reactiveForm = this.formBuilder.group({
      companyName: [{ value: '', disabled: true }],
      abn: [{ value: '', disabled: true }],
      website: [''],
      email: [''],
      phoneNumber: [''],
      addressLine1: [''],
      addressLine2: [{ value: '', disabled: true }],
      area: [{ value: '', disabled: true }],
      city: [{ value: '', disabled: true }],
      state: [{ value: '', disabled: true }],
      postCode: [{ value: '', disabled: true }],
      country: [{ value: '', disabled: true }],
      description: ['']
    });
  }

  ngOnInit(): void {
    this.userService.currentUser.subscribe((user: any) => {
      this.highestRole = user.roles[0];
      if (this.highestRole.weight < 1000) {
        this.router.navigateByUrl('/profile');
      }
      this.httpService.getCompanyById(user.company.id).subscribe((res: any) => {
        console.log(res);
        this.company = res.data;
        this.reactiveForm.patchValue({
          companyName: this.company.name,
          abn: this.company.abn,
          website: this.company.website ? this.company.website : '',
          description: this.company.notes ? this.company.notes : '',
          addressLine1: this.company.addressLine1 ? this.company.addressLine1 : '',
          addressLine2: this.company.addressLine2,
          area: this.company.area ? this.company.area : '',
          state: this.company.state ? this.company.state : '',
          city: this.company.city ? this.company.city : '',
          postCode: this.company.postCode ? this.company.postCode : '',
          country: this.company.country ? this.company.country : '',
          email: this.company.email ? this.company.email : '',
          phoneNumber: this.company.phoneNumber ? this.company.phoneNumber : '',

        });
      });
    });
  }

  onFeatureImageChange(event) {
    if (event.target.files[0].size > 1048576) {
      this.toastrService.error('Failed to update logo (max 1MB)');
      return
    }
    if (event.target.files && event.target.files[0]) {
      // const filesAmount = event.target.files.length;
      this.selectedImage = []
      for (let i = 0; i < 1; i++) {
        if (event.target.files[i].size <= Constants.UPLOAD_TERMS_FILE_SIZE) {
          this.selectedImage.push(event.target.files[i]);
        }
      }
      console.log(this.selectedImage);
    }
  }

  onBannerImageChange(event) {
    if (event.target.files[0].size > 1048576) {
      this.toastrService.error('Failed to update banner (max 1MB)');
      return
    }
    if (event.target.files && event.target.files[0]) {
      // const filesAmount = event.target.files.length;
      this.selectedBanner = []
      for (let i = 0; i < 1; i++) {
        if (event.target.files[i].size <= Constants.UPLOAD_TERMS_FILE_SIZE) {
          this.selectedBanner.push(event.target.files[i]);
        }
      }
      console.log(this.selectedBanner);
    }
  }

  uploadLogo() {
    const fd = new FormData();
    fd.append('logo', this.selectedImage[0]);
    this.userService.currentUser.subscribe((user: any) => {
      // console.log(user);
      this.httpService.uploadCompanyLogo(fd, user.company.id).subscribe((res: any) => {
        console.log(res);
        if (res.code === 1) {
          this.company = res.data;
          this.selectedImage = [];
          this.toastrService.success('Company logo uploading successful');
          this.router.navigateByUrl('/profile');
        } else {
          this.toastrService.error('Company logo uploading failed');
        }
      });
    });
  }

  uploadBanner() {
    const fd = new FormData();
    fd.append('banner', this.selectedBanner[0]);
    this.userService.currentUser.subscribe((user: any) => {
      // console.log(user);
      this.httpService.uploadCompanyBanner(fd, user.company.id).subscribe((res: any) => {
        console.log(res);
        if (res.code === 1) {
          this.company = res.data;
          this.selectedBanner = [];
          this.toastrService.success('Company banner uploading successful');
          this.router.navigateByUrl('/profile');
        } else {
          this.toastrService.error('Company banner uploading failed');
        }
      });
    });
  }

  getAddress(address: any) {
    console.log(address);
    const components = address.address_components;
    let addressLine2 = '';
    let area = '';
    let city = '';
    let state = '';
    let country = '';
    let postCode = '';
    components.forEach((component: { long_name: string; short_name: string; types: Array<string> }) => {
      if (component.types.find(type => type === 'street_number')) {
        addressLine2 = component.long_name;
      } else if (component.types.find(type => type === 'route')) {
        addressLine2 += ' ' + component.long_name;
      } else if (component.types.find(type => type === 'locality')) {
        area = component.long_name;
      } else if (component.types.find(type => type === 'administrative_area_level_2')) {
        city = component.short_name;
      } else if (component.types.find(type => type === 'administrative_area_level_1')) {
        state = component.short_name;
      } else if (component.types.find(type => type === 'country')) {
        country = component.long_name;
      } else if (component.types.find(type => type === 'postal_code')) {
        postCode = component.long_name;
      }
    });
    // console.log(address);
    this.reactiveForm.get('addressLine2').setValue(addressLine2);
    this.reactiveForm.get('area').setValue(area);
    this.reactiveForm.get('city').setValue(city);
    this.reactiveForm.get('state').setValue(state);
    this.reactiveForm.get('country').setValue(country);
    this.reactiveForm.get('postCode').setValue(postCode);

    this.cdr.detectChanges();
  }

  updateCompanyInfo() {
    const fd = new FormData();
    if (this.company.website !== this.reactiveForm.get('website').value) {
      fd.append('website', this.reactiveForm.get('website').value);
    }
    if (this.company.notes !== this.reactiveForm.get('description').value) {
      fd.append('notes', this.reactiveForm.get('description').value);
    }
    if (this.company.addressLine1 !== this.reactiveForm.get('addressLine1').value) {
      fd.append('addressLine1', this.reactiveForm.get('addressLine1').value);
    }
    if (this.company.addressLine2 !== this.reactiveForm.get('addressLine2').value) {
      fd.append('addressLine2', this.reactiveForm.get('addressLine2').value);
    }
    if (this.company.area !== this.reactiveForm.get('area').value) {
      fd.append('area', this.reactiveForm.get('area').value);
    }
    if (this.company.city !== this.reactiveForm.get('city').value) {
      fd.append('city', this.reactiveForm.get('city').value);
    }
    if (this.company.state !== this.reactiveForm.get('state').value) {
      fd.append('state', this.reactiveForm.get('state').value);
    }
    if (this.company.postCode !== this.reactiveForm.get('postCode').value) {
      console.log(this.reactiveForm.get('postCode').value);
      fd.append('postCode', this.reactiveForm.get('postCode').value);
    }
    if (this.company.country !== this.reactiveForm.get('country').value) {
      fd.append('country', this.reactiveForm.get('country').value);
    }

    if (this.company.email !== this.reactiveForm.get('email').value) {
      fd.append('email', this.reactiveForm.get('email').value);
    }

    if (this.company.phoneNumber !== this.reactiveForm.get('phoneNumber').value) {
      fd.append('phoneNumber', this.reactiveForm.get('phoneNumber').value);
    }

    this.httpService.editCompanyInfo(fd, this.company.id).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('Company info has been updated.');
        this.company = res.data;
        this.reactiveForm.patchValue({
          companyName: this.company.name,
          abn: this.company.abn,
          website: this.company.website ? this.company.website : '',
          description: this.company.notes ? this.company.notes : '',
          addressLine1: this.company.addressLine1 ? this.company.addressLine1 : '',
          addressLine2: this.company.addressLine2 ? this.company.addressLine2 : '',
          area: this.company.area ? this.company.area : '',
          state: this.company.state ? this.company.state : '',
          city: this.company.city ? this.company.city : '',
          postCode: this.company.postCode ? this.company.postCode : '',
          country: this.company.country ? this.company.country : ''
        });
        this.router.navigateByUrl('/profile');
      } else {
        this.toastrService.error('Failed to update company info');
      }
    });
  }

}
